import React, { Component } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import { Button, Row, Col, Form, Container } from 'react-bootstrap';
import Select from 'react-select';
import { Query, withApollo } from "react-apollo";
import { addParticipantModalUserListQuery, papelListQuery } from '../../../graphql/Outros';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
const AsyncTypeahead = asyncContainer(Typeahead);

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    inputMargin: {
        marginBottom: '20px'
    },
    title: {
        marginBottom: '20px'
    }
});

class ProlongarSessao extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            addParticipanteId: null,
            addParticipantePapel: null,
            userListOptions: [],
            isLoadingUserList: false,
            enumsLoaded: false,
            enums: [],
            showSwalTeste: false,
        }

        this.handleAsyncOnSearch = this.handleAsyncOnSearch.bind(this);
        this.handleAsyncOnChange = this.handleAsyncOnChange.bind(this);
        this.handlePapelUsuario = this.handlePapelUsuario.bind(this);
        this.handleAddParticipant = this.handleAddParticipant.bind(this);

    }

    componentDidMount() {
        let enumsQueries = [
            this.props.client.query({
                query: papelListQuery,
                variables: {
                archived: false,
                },
                fetchPolicy: "network-only"
            })
        ];
        Promise.all(enumsQueries).then((data) => {
            this.setState({
                enumsLoaded: true,
                enums: Object.assign({}, ...data.map(e => e.data))
            });
        });
    }

    render() {
        const { classes, handleModalClose } = this.props;
        const { userListOptions, isLoadingUserList, enumsLoaded } = this.state;

        const papeisList = enumsLoaded ? this.state.enums.papelList : [];

        const defaultPapel = papeisList.filter( papel => papel.id_descritivo == 'participante')[0];

        if(!defaultPapel) {
            return <Paper className={classes.root}>
                Carregando
            </Paper>;
        }

        if(!this.state.addParticipantePapel) {
            setTimeout(()=>this.handlePapelUsuario(defaultPapel), 0);
        }

        return (
            <Paper className={classes.root}>
                <Container style={{minWidth: 500}}>
                    <Row>
                        <Col className={classes.headerWrapper}>
                            <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Typography variant="h3" className={classes.title}>Adicionar convidado</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <AsyncTypeahead
                                placeholder={"Nome do usuário"}
                                id={'search-users'}
                                onSearch={this.handleAsyncOnSearch}
                                onChange={this.handleAsyncOnChange}
                                options={userListOptions}
                                labelKey="display_name"
                                isLoading={isLoadingUserList}
                                className={classes.inputMargin}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Select
                                onChange={this.handlePapelUsuario}
                                options={papeisList}
                                defaultValue={defaultPapel}
                                getOptionValue={(el) => el.id}
                                getOptionLabel={(el) => el.nome}
                                placeholder="Papel do usuário"
                                className={classes.inputMargin}>
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={classes.buttonsActionWrapper}>
                            <Button variant="green" type="submit" onClick={this.handleAddParticipant}>OK</Button>
                        </Col>
                    </Row>
                </Container>
            </Paper>
        )
    }

    handleAddParticipant() {
        const { handleModalSaveChange } = this.props;
        const { addParticipanteId, addParticipantePapel } = this.state;

        if ( !addParticipanteId || !addParticipantePapel) {
            return;
        }

        handleModalSaveChange(addParticipanteId, addParticipantePapel);
    }

    handleAsyncOnSearch(queryString) {
        if (queryString.length < 4) return;

        this.setState({ isLoadingUserList: true });
        const { client } = this.props;

        client.query({
            query: addParticipantModalUserListQuery,
            variables: {
                nome: queryString,
            },
            fetchPolicy: "network-only"
        }).then(response => {
            const { usuarioAutoComplete } = response.data;

            usuarioAutoComplete.forEach( el => {
                const login = el.email.split('@')[0];
                el['display_name'] = el.nome + ' ( '+login+' )';
            });

            this.setState({
                userListOptions: usuarioAutoComplete,
                isLoadingUserList :false,
            });
        });
    }

    handleAsyncOnChange(selectedItem) {
        this.setState({
            addParticipanteId: selectedItem[0].id
        });
    }

    handlePapelUsuario(selected) {
        this.setState({
            addParticipantePapel: selected.id
        });
    }

}

export default withStyles(classes)(withApollo(ProlongarSessao));